import { render } from "./MediumIcon.vue?vue&type=template&id=4bd83510"
const script = {}
script.render = render

export default script